/**
 * Asynchronously loads the component for ActivityWidgetContainer
 */
import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./ActivityWidgetContainer'),
  loading: () => null,
});
